import { render, staticRenderFns } from "./estimateTab.vue?vue&type=template&id=31dc54b2&scoped=true&"
import script from "./estimateTab.vue?vue&type=script&lang=js&"
export * from "./estimateTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31dc54b2",
  null
  
)

export default component.exports